<template>

  <el-dialog
    title="选择商品"
    :visible.sync="visible"
    append-to-body
    width="60%"
    :close-on-press-escape="false">
    <el-form
      :inline="true"
      style="display:flex;justify-content: space-between;"
      @submit.native.prevent>
      <el-form-item>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="config.productName"
          placeholder="请输入商品名称"
          style="width: 200px">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <el-table
      ref="table"
      v-loading="loading"
      border
      :data="list"
      row-key="productId"
      @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        reserve-selection
        width="55">
      </el-table-column>
      <el-table-column
        label="商品名称"
        prop="productName">
      </el-table-column>
      <el-table-column
        label="商品编号"
        width="160"
        :resizable="false"
        prop="productNumber">
      </el-table-column>
      <el-table-column
        label="商品品种"
        width="120"
        :resizable="false"
        prop="categoryName">
      </el-table-column>
      <el-table-column
        label="商品系列"
        width="120"
        :resizable="false"
        prop="productLineName">
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :current-page.sync="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="total"
      @current-change="handleCurrentChange">
    </el-pagination>
    <span
      slot="footer"
      class="dialog-footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>

</template>
<script>
export default {
  name: 'DistributionModal',
  components: {},
  props: {
    option: {
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      init: true,
      config: {
        pageNum: 1,
        pageSize: 10,
        productName: ''
        // productTypes: [1, 9]
      },
      list: [],
      total: 0,
      multipleSelection: []
    }
  },
  computed: {},
  watch: {
    visible(val) {
      if (val) {
        if (this.init) {
          this.init = false
          this.fetchList()
        }
      }
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('product/getproducts', {
        payload: {
          ...this.config,
          ...this.option
        },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    reset() {
      this.init = true
      this.config.pageNum = 1
      this.list = []
      this.total = 0
      this.multipleSelection = []
      this.$refs.table && this.$refs.table.clearSelection()
    },
    handleSubmit() {
      this.$emit('update:list', this.multipleSelection)
      this.toggleModal(false)
    }
  }
}
</script>
<style lang="stylus" scoped></style>
